<template>
  <!-- <div></div> -->
  <div class="swiper-container swipersBox"
    :id="'swiper' + awardIndex">
    <div class="swiper-wrapper">
      <div class="swiper-slide part3_mess_pre"
        v-for="(item, index) in awardList"
        :key="index">
        <p class="pre_part3_tit">{{ item.awardName }}</p>
        <p class="pre_part3_tit2">{{ item.awardContent }}</p>
        <img :src="item.awardUrl"/>
        
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  props: {
    awardList: {
      type: Array,
      default: () => []
    },
    awardIndex: {
      type: Number,
    }
  },

  data () {
    return {
      loopImgs: false,

    }
  },
  created(){
    if(this.awardList.length > 3) {
      this.loopImgs = true
    }
  },
  mounted () {
    let that = this

    new Swiper("#swiper"+ this.awardIndex, {
      direction: "horizontal",
      initialSlide: 1,//默认第二页
      loop : that.loopImgs, //环路，让Swiper看起来是循环的
      speed : 600, //速度
      freeMode : true, //根据惯性滑动可能不止一格且不会贴合
      observer : true, //修改swiper自己或子元素时，自动初始化swiper
      autoplay : that.loopImgs, //自动切换
      // autoplay: false,
      observer: true,
      observeParents: true,
      effect: "coverflow",
      slidesPerView: "auto",
      centeredSlides: true,
      coverflowEffect: {
        rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
        stretch: -5, //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
        depth: 20, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
        modifier: 5,
        slideShadows: false, //开启slide阴影。默认 true。
      },
    });
  },
  components: {
  },
  methods: {
  }
}
</script> 
<style scoped lang="less">
.part3_mess_pre {
  font-size: 18px;
  color: #000000;
  width: 240px;
  height: 234px;
  border-radius: 10px;
  margin-right: 47px;
  flex-shrink: 0;
  margin-top: 20px;
  .pre_part3_tit {
    text-align: center;
    font-size: 21px;
    margin-top: 12px;
    color:#2486FB
  }
  .pre_part3_tit2 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 10px;
  }
  img {
    width: 240px;
    height: 135px;
    margin-top: 20px;
  }
}
.swipersBox {
  width: 100%;
  padding-top: 36px;
  margin-top: 36px;
  background: #fff;
  width: 94%;
  margin-top: 0;
  padding-top: 0;
  height: 300px;
  border-radius: 10px;

}
</style>


// WEBPACK FOOTER //
// src/components/design/activeList/carouselBox3.vue